export const token = localStorage.getItem("token");
export const isLoggedIn = () => {
  return localStorage.getItem("token")?.length > 0;
};
